import { CallStatus } from './types';

export function callStatusTranslation(status: CallStatus) {
  switch (status) {
    case CallStatus.SENT:
      return 'Enviada';
    case CallStatus.ACCEPTED:
      return 'Aceptada';
    case CallStatus.REJECTED:
      return 'Rechazada';
    default:
      return '';
  }
}
